// extracted by mini-css-extract-plugin
export var alignLeft = "m_p4 d_fn d_bF d_dt";
export var alignCenter = "m_bN d_fp d_bC d_dv";
export var alignRight = "m_p5 d_fq d_bG d_dw";
export var FAQMainHeader = "m_kt d_kt d_v d_bx";
export var FAQComponentHeader = "m_kz d_kz d_bw";
export var FAQComponentParagraph = "m_kv d_kv d_cC";
export var FAQComponentsWrapper = "m_kr d_kr d_cm d_cK d_cQ d_c1 d_cW d_dz";
export var FAQComponentsWrapperClean = "m_ks d_ks d_cm d_cK d_cQ d_cZ d_dz";
export var accordion__body = "m_kB d_kB d_bx";
export var accordion__bodyHidden = "m_kD d_kD d_bv d_dk";
export var FAQDivider = "m_kq d_kq";
export var accordionWrapper = "m_p6 d_cf";
export var accordion__item = "m_p7 d_cK";
export var accordion_arrow = "m_kH d_kH";
export var accordion_arrow_open = "m_kK d_kK";
export var accordion_arrow_2 = "m_kM d_kM";
export var accordion_arrow_2_open = "m_kP d_kP";
export var Subtitle2Small = "m_p8 q_p8 q_qK q_qZ";
export var Subtitle2Normal = "m_p9 q_p9 q_qK q_q0";
export var Subtitle2Large = "m_qb q_qb q_qK q_q1";